import React from 'react';
import { Outlet } from 'react-router-dom';

export const Deliveries: React.FC = () => {
  return <Outlet />;
};
